import { STATUS_CODE, STATUS_Message } from "../utils/enum/ResponseEnum";

const ERROR_CONFIG = new Map([
  [STATUS_CODE.unauthorized, STATUS_Message.unauthorized],
  [STATUS_CODE.notFound, STATUS_Message.notFound],
  [STATUS_CODE.serverError, STATUS_Message.serverError],
]);

export default ERROR_CONFIG;
